/**
 * index.js
 *
 * @Author: wangyinan
 * @Date: 2017/7/12 下午6:26
 */

import Input from './Input';

export default Input;



// WEBPACK FOOTER //
// ./src/input/index.js